<template>
  <div>
    <h4 class="question _margin-bottom-10">
      Do you own or regularly charge an Electric Vehicle at home?
    </h4>

    <p class="_margin-top-0 _margin-bottom-30">
      This helps us recommend the most suitable time-of-use tariff for your household energy needs. EVs can benefit from
      special tariffs like off-peak charging.
    </p>

    <div class="row">
      <div class="col-xs-12 col-md-6">
        <radio-button v-model="quote.evOwnership" value="Yes" @change="onChoose" :error="$v.propertyUsage.$error">
          Yes
        </radio-button>
        <div class=" text-center">
          I have an EV or regularly charge one at home
        </div>
      </div>

      <div class="col-xs-12 col-md-6">
        <radio-button v-model="quote.evOwnership" value="No" @change="onChoose" :error="$v.propertyUsage.$error">
          No
        </radio-button>
        <div class=" text-center">
          I don't have or charge an EV at home
        </div>
      </div>
    </div>

    <uiv-alert type="danger" v-if="error">
      <b>Error</b> <br />
      {{ error }}
    </uiv-alert>

    <div class="card-footer">
      <div class="col-xs-6">
        <uiv-btn @click="onBack">Back</uiv-btn>
      </div>

      <div class="col-xs-6 text-right">
        <uiv-btn type="primary" @click="onGoToQuestion('next')" :disabled="$v.electricVehicleOwnership.$invalid">
          Next
        </uiv-btn>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'ElectricVehicleOwnership',
  data() {
    return {
      error: null
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      houseUsageTypes: ({ lookups }) => lookups.houseUsageTypes
    }),
    ...mapGetters({
      progress: 'quote_questions/progress'
    })
  },
  methods: {
    ...mapActions({
      goToQuestion: 'quote_questions/goToQuestion'
    }),
    async onChoose(p) {
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Electric Vehicle Ownership' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Choose' });
      this.$store.dispatch('tracing/addAction', { name: 'Value', value: p });
      this.quote.electricVehicleOwnership = p;

      await this.$store.dispatch('tracing/saveActions');
    },
    onBack() {
      this.goToQuestion({ type: 'prev' });
      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Electric Vehicle Ownership' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Back' });
      this.$store.dispatch('tracing/saveActions');
    },
    async onGoToQuestion(type) {
      this.$v.electricVehicleOwnership.$touch();
      this.error = null;
      if (this.$v.electricVehicleOwnership.$invalid) return;

      this.$store.dispatch('tracing/addAction', { name: 'Step', value: 'Electric Vehicle Ownership' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Next' });
      await this.$store.dispatch('tracing/saveActions');

      const lastStep = await this.goToQuestion({ type });
      if (lastStep) {
        const error = await this.$store.dispatch('quote/newQuote', 'solar');
        this.error = error;
        if (!error) {
          this.$router.push({ name: 'quoteResults' });
        }
      }
    }
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss"></style>
